import { css } from "@emotion/react";

export const lineClamp1Css = css`
  margin: 0;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  word-break: break-word;
`;

export const lineClamp2Css = [
  lineClamp1Css,
  css`
    -webkit-line-clamp: 2;
  `,
];
